export enum SgSdkModules {
  BASIC     = "basic",
  LEVELGAME = "levelGame",
  SCOREGAME = "scoreGame"
};

export enum TriggerAction {
  /* Core */
  START                      = "start",
  LOADING_COMPLETED          = "loading.completed",
  LOADING_UPDATE             = "loading.update",
  /* Data persistence */
  SAVE                       = "save",
  RESTORE                    = "restore",
  /* Monetization */
  REWARDED_AD                = "rewardedAd",
  BEFORE_PLAY_BUTTON_DISPLAY = "beforePlayButtonDisplay",
  PLAY_BUTTON_PRESSED        = "playButtonPressed",
  /* Others */
  MORE_GAMES                 = "moreGames",
  GAME_TRACKING              = "gameTracking",
  /* Level Game */
  LEVEL_START                = "levelStart",
  LEVEL_FINISH               = "levelFinish",
  /* Score Game */
  GAME_START                 = "gameStart",
  GAME_OVER                  = "gameOver",
}

export type SgSdkInitializeCallback = (
  error: unknown | null,
  settings: ISgSdkSettings,
  sdkHandler: ISgSdkHandler,
) => void;

export type SgSdkTriggerFunction = (
  action: TriggerAction,
  options?: any,
  context?: any,
) => void;

export interface ISgSdk {
  initialize(
    modules: Array<SgSdkModules>,
    commands: ISgSdkCommands,
    callback: SgSdkInitializeCallback,
  ): void;
};

export interface ISgSdkHandler {
  lang:String;
  trigger: SgSdkTriggerFunction;
}

export interface ISgSdkCommands {
  id: string;
  build: string;
  supportedLanguages: Array<string>;
  unfreezeGame: () => void;
  freezeGame: () => void;
  runGame: () => void;
  goToLevel?: (level: number) => void;
  getScore?: () => number;
  startOver?: () => void;
  changeLocale?: (locale: string) => void;
}

export interface ISgSdkSettings {
  commands: ISgSdkCommands;
  config: IGameConfig;
}


export interface IGameConfig {
  game: {
    id: number;
    slug: string;
  };
  publisher: {
    id: number;
    name: string;
  };
  env: {
    locale: string;
    anotherTab?: boolean;
  };
  crossPromotion: {
    enabled: boolean;
    link?: string;
  };
  moreGames: {
    displayButton?: boolean;
  };
  bannerUrl: {
    logo?: string;
  };
  user: IUserData;
  rewarded: {
    enabled: boolean;
  };
  abTesting?: unknown;
}

export interface IUserData {
  userId: number;
  authToken: string;
  name: string;
  known: boolean;
  validEmail: boolean;
  avatar: string;
  avatarBase64?: string;
}
